import React from 'react';
import styled from 'styled-components6';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { SourceIcon } from 'rwl-ui';
import { ContentSource } from 'rwl-shared/dist/models/ContentSource';

type ReviewBadgeProps = {
    reviewSource: ContentSource | undefined;
};

const BadgeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1px;
    background: #ffffff;
    border-radius: 12px;
    padding: 1px 3px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    border: 0.5px solid #e0e0e0;
    height: 14px;
    width: auto;
`;

const IconWrapper = styled.div<{
    size?: string;
    color?: string;
    fontSize?: string;
}>`
    display: flex;
    align-items: center;
    width: ${(props) => props.size || '10px'};
    height: ${(props) => props.size || '10px'};
    color: ${(props) => props.color || 'inherit'};
    font-size: ${(props) => props.fontSize || 'inherit'};

    svg {
        width: ${(props) => props.size || '10px'} !important;
        height: ${(props) => props.size || '10px'} !important;
    }
`;

export const ReviewBadge: React.FC<ReviewBadgeProps> = ({ reviewSource }) => {
    if (!reviewSource) {
        return null;
    }

    const isGMBorFB =
        reviewSource === ContentSource.GMB ||
        reviewSource === ContentSource.Facebook;

    return (
        <BadgeContainer>
            {isGMBorFB && (
                <IconWrapper size="10px">
                    <SourceIcon source={reviewSource} />
                </IconWrapper>
            )}
            <IconWrapper size="10px" color="#ffb400" fontSize="8px">
                <FontAwesomeIcon icon={faStar} />
            </IconWrapper>
        </BadgeContainer>
    );
};

export default ReviewBadge;
